//import { normalize, denormalize, schema } from 'normalizr';
import { normalize, schema } from 'normalizr'

const flowchart = new schema.Entity('flowcharts')
const flowchartSchema = [ flowchart ]
//export const normalizeFlowchart = originalData => normalize(originalData,flowchart)
export const normalizeFlowcharts = originalData => normalize(originalData,flowchartSchema)
//export const denormalizeFlowcharts = (normalizeFlowcharts,entities) => denormalize(normalizeFlowcharts,flowchartSchema,entities)